import type { OutlineProps } from "@op/puck-types";

const Outline = (_: OutlineProps) => {
  return null;
};

export default Outline;
